// assets/playerIconMap.js

// man_turquoise
import rightFrame1mt from "assets/puzzles/iserba/player/man_turquoise/right_frame_1.svg";
import rightFrame2mt from "assets/puzzles/iserba/player/man_turquoise/right_frame_2.svg";
import rightFrame3mt from "assets/puzzles/iserba/player/man_turquoise/right_frame_3.svg";
import rightFrame4mt from "assets/puzzles/iserba/player/man_turquoise/right_frame_4.svg";

import leftFrame1mt from "assets/puzzles/iserba/player/man_turquoise/left_frame_1.svg";
import leftFrame2mt from "assets/puzzles/iserba/player/man_turquoise/left_frame_2.svg";
import leftFrame3mt from "assets/puzzles/iserba/player/man_turquoise/left_frame_3.svg";
import leftFrame4mt from "assets/puzzles/iserba/player/man_turquoise/left_frame_4.svg";

import topFrame1mt from "assets/puzzles/iserba/player/man_turquoise/up_frame_1.svg";
import topFrame2mt from "assets/puzzles/iserba/player/man_turquoise/up_frame_2.svg";
import topFrame3mt from "assets/puzzles/iserba/player/man_turquoise/up_frame_3.svg";
import topFrame4mt from "assets/puzzles/iserba/player/man_turquoise/up_frame_4.svg";

import bottomFrame1mt from "assets/puzzles/iserba/player/man_turquoise/bottom_frame_1.svg";
import bottomFrame2mt from "assets/puzzles/iserba/player/man_turquoise/bottom_frame_2.svg";
import bottomFrame3mt from "assets/puzzles/iserba/player/man_turquoise/bottom_frame_3.svg";
import bottomFrame4mt from "assets/puzzles/iserba/player/man_turquoise/bottom_frame_4.svg";

import fallingRightFrame1mt from "assets/puzzles/iserba/player/man_turquoise/falling_frame_right_1.svg";
import fallingRightFrame2mt from "assets/puzzles/iserba/player/man_turquoise/falling_frame_right_2.svg";

import fallingLeftFrame1mt from "assets/puzzles/iserba/player/man_turquoise/falling_frame_left_1.svg";
import fallingLeftFrame2mt from "assets/puzzles/iserba/player/man_turquoise/falling_frame_left_2.svg";

// woman_purple
import rightFrame1wp from "assets/puzzles/iserba/player/woman_purple/right_frame_1.svg";
import rightFrame2wp from "assets/puzzles/iserba/player/woman_purple/right_frame_2.svg";
import rightFrame3wp from "assets/puzzles/iserba/player/woman_purple/right_frame_3.svg";
import rightFrame4wp from "assets/puzzles/iserba/player/woman_purple/right_frame_4.svg";

import leftFrame1wp from "assets/puzzles/iserba/player/woman_purple/left_frame_1.svg";
import leftFrame2wp from "assets/puzzles/iserba/player/woman_purple/left_frame_2.svg";
import leftFrame3wp from "assets/puzzles/iserba/player/woman_purple/left_frame_3.svg";
import leftFrame4wp from "assets/puzzles/iserba/player/woman_purple/left_frame_4.svg";

import topFrame1wp from "assets/puzzles/iserba/player/woman_purple/up_frame_1.svg";
import topFrame2wp from "assets/puzzles/iserba/player/woman_purple/up_frame_2.svg";
import topFrame3wp from "assets/puzzles/iserba/player/woman_purple/up_frame_3.svg";
import topFrame4wp from "assets/puzzles/iserba/player/woman_purple/up_frame_4.svg";

import bottomFrame1wp from "assets/puzzles/iserba/player/woman_purple/bottom_frame_1.svg";
import bottomFrame2wp from "assets/puzzles/iserba/player/woman_purple/bottom_frame_2.svg";
import bottomFrame3wp from "assets/puzzles/iserba/player/woman_purple/bottom_frame_3.svg";
import bottomFrame4wp from "assets/puzzles/iserba/player/woman_purple/bottom_frame_4.svg";

import fallingRightFrame1wp from "assets/puzzles/iserba/player/woman_purple/falling_frame_right_1.svg";
import fallingRightFrame2wp from "assets/puzzles/iserba/player/woman_purple/falling_frame_right_2.svg";

import fallingLeftFrame1wp from "assets/puzzles/iserba/player/woman_purple/falling_frame_left_1.svg";
import fallingLeftFrame2wp from "assets/puzzles/iserba/player/woman_purple/falling_frame_left_2.svg";

// man_purple
import rightFrame1mp from "assets/puzzles/iserba/player/man_purple/right_frame_1.svg";
import rightFrame2mp from "assets/puzzles/iserba/player/man_purple/right_frame_2.svg";
import rightFrame3mp from "assets/puzzles/iserba/player/man_purple/right_frame_3.svg";
import rightFrame4mp from "assets/puzzles/iserba/player/man_purple/right_frame_4.svg";

import leftFrame1mp from "assets/puzzles/iserba/player/man_purple/left_frame_1.svg";
import leftFrame2mp from "assets/puzzles/iserba/player/man_purple/left_frame_2.svg";
import leftFrame3mp from "assets/puzzles/iserba/player/man_purple/left_frame_3.svg";
import leftFrame4mp from "assets/puzzles/iserba/player/man_purple/left_frame_4.svg";

import fallingRightFrame1mp from "assets/puzzles/iserba/player/man_purple/falling_frame_right_1.svg";
import fallingRightFrame2mp from "assets/puzzles/iserba/player/man_purple/falling_frame_right_2.svg";

import fallingLeftFrame1mp from "assets/puzzles/iserba/player/man_purple/falling_frame_left_1.svg";
import fallingLeftFrame2mp from "assets/puzzles/iserba/player/man_purple/falling_frame_left_2.svg";

// man_purple_2
import rightFrame1mp2 from "assets/puzzles/iserba/player/man_purple_2/right_frame_1.svg";
import rightFrame2mp2 from "assets/puzzles/iserba/player/man_purple_2/right_frame_2.svg";
import rightFrame3mp2 from "assets/puzzles/iserba/player/man_purple_2/right_frame_3.svg";
import rightFrame4mp2 from "assets/puzzles/iserba/player/man_purple_2/right_frame_4.svg";

import leftFrame1mp2 from "assets/puzzles/iserba/player/man_purple_2/left_frame_1.svg";
import leftFrame2mp2 from "assets/puzzles/iserba/player/man_purple_2/left_frame_2.svg";
import leftFrame3mp2 from "assets/puzzles/iserba/player/man_purple_2/left_frame_3.svg";
import leftFrame4mp2 from "assets/puzzles/iserba/player/man_purple_2/left_frame_4.svg";

import fallingRightFrame1mp2 from "assets/puzzles/iserba/player/man_purple_2/falling_frame_right_1.svg";
import fallingRightFrame2mp2 from "assets/puzzles/iserba/player/man_purple_2/falling_frame_right_2.svg";

import fallingLeftFrame1mp2 from "assets/puzzles/iserba/player/man_purple_2/falling_frame_left_1.svg";
import fallingLeftFrame2mp2 from "assets/puzzles/iserba/player/man_purple_2/falling_frame_left_2.svg";

// woman_purple_2
import rightFrame1wp2 from "assets/puzzles/iserba/player/woman_purple_2/right_frame_1.svg";
import rightFrame2wp2 from "assets/puzzles/iserba/player/woman_purple_2/right_frame_2.svg";
import rightFrame3wp2 from "assets/puzzles/iserba/player/woman_purple_2/right_frame_3.svg";
import rightFrame4wp2 from "assets/puzzles/iserba/player/woman_purple_2/right_frame_4.svg";

import leftFrame1wp2 from "assets/puzzles/iserba/player/woman_purple_2/left_frame_1.svg";
import leftFrame2wp2 from "assets/puzzles/iserba/player/woman_purple_2/left_frame_2.svg";
import leftFrame3wp2 from "assets/puzzles/iserba/player/woman_purple_2/left_frame_3.svg";
import leftFrame4wp2 from "assets/puzzles/iserba/player/woman_purple_2/left_frame_4.svg";

import fallingRightFrame1wp2 from "assets/puzzles/iserba/player/woman_purple_2/falling_frame_right_1.svg";
import fallingRightFrame2wp2 from "assets/puzzles/iserba/player/woman_purple_2/falling_frame_right_2.svg";

import fallingLeftFrame1wp2 from "assets/puzzles/iserba/player/woman_purple_2/falling_frame_left_1.svg";
import fallingLeftFrame2wp2 from "assets/puzzles/iserba/player/woman_purple_2/falling_frame_left_2.svg";

// woman_purple_3
import rightFrame1wp3 from "assets/puzzles/iserba/player/woman_purple_3/right_frame_1.svg";
import rightFrame2wp3 from "assets/puzzles/iserba/player/woman_purple_3/right_frame_2.svg";
import rightFrame3wp3 from "assets/puzzles/iserba/player/woman_purple_3/right_frame_3.svg";
import rightFrame4wp3 from "assets/puzzles/iserba/player/woman_purple_3/right_frame_4.svg";

import leftFrame1wp3 from "assets/puzzles/iserba/player/woman_purple_3/left_frame_1.svg";
import leftFrame2wp3 from "assets/puzzles/iserba/player/woman_purple_3/left_frame_2.svg";
import leftFrame3wp3 from "assets/puzzles/iserba/player/woman_purple_3/left_frame_3.svg";
import leftFrame4wp3 from "assets/puzzles/iserba/player/woman_purple_3/left_frame_4.svg";

import fallingRightFrame1wp3 from "assets/puzzles/iserba/player/woman_purple_3/falling_frame_right_1.svg";
import fallingRightFrame2wp3 from "assets/puzzles/iserba/player/woman_purple_3/falling_frame_right_2.svg";

import fallingLeftFrame1wp3 from "assets/puzzles/iserba/player/woman_purple_3/falling_frame_left_1.svg";
import fallingLeftFrame2wp3 from "assets/puzzles/iserba/player/woman_purple_3/falling_frame_left_2.svg";

export const playerSpriteSets = {
	man_turquoise: {
		walking: {
			right: [rightFrame1mt, rightFrame2mt, rightFrame3mt, rightFrame4mt],
			left: [leftFrame1mt, leftFrame2mt, leftFrame3mt, leftFrame4mt],
			up: [topFrame1mt, topFrame2mt, topFrame3mt, topFrame4mt],
			down: [bottomFrame1mt, bottomFrame2mt, bottomFrame3mt, bottomFrame4mt],
		},
		falling: {
			right: [fallingRightFrame1mt, fallingRightFrame2mt],
			left: [fallingLeftFrame1mt, fallingLeftFrame2mt],
		},
	},
	man_purple: {
		walking: {
			right: [rightFrame1mp, rightFrame2mp, rightFrame3mp, rightFrame4mp],
			left: [leftFrame1mp, leftFrame2mp, leftFrame3mp, leftFrame4mp],
		},
		falling: {
			right: [fallingRightFrame1mp, fallingRightFrame2mp],
			left: [fallingLeftFrame1mp, fallingLeftFrame2mp],
		},
	},
	man_purple_2: {
		walking: {
			right: [rightFrame1mp2, rightFrame2mp2, rightFrame3mp2, rightFrame4mp2],
			left: [leftFrame1mp2, leftFrame2mp2, leftFrame3mp2, leftFrame4mp2],
		},
		falling: {
			right: [fallingRightFrame1mp2, fallingRightFrame2mp2],
			left: [fallingLeftFrame1mp2, fallingLeftFrame2mp2],
		},
	},
	woman_purple: {
		walking: {
			right: [rightFrame1wp, rightFrame2wp, rightFrame3wp, rightFrame4wp],
			left: [leftFrame1wp, leftFrame2wp, leftFrame3wp, leftFrame4wp],
			up: [topFrame1wp, topFrame2wp, topFrame3wp, topFrame4wp],
			down: [bottomFrame1wp, bottomFrame2wp, bottomFrame3wp, bottomFrame4wp],
		},
		falling: {
			right: [fallingRightFrame1wp, fallingRightFrame2wp],
			left: [fallingLeftFrame1wp, fallingLeftFrame2wp],
		},
	},
	woman_purple_2: {
		walking: {
			right: [rightFrame1wp2, rightFrame2wp2, rightFrame3wp2, rightFrame4wp2],
			left: [leftFrame1wp2, leftFrame2wp2, leftFrame3wp2, leftFrame4wp2],
		},
		falling: {
			right: [fallingRightFrame1wp2, fallingRightFrame2wp2],
			left: [fallingLeftFrame1wp2, fallingLeftFrame2wp2],
		},
	},
	woman_purple_3: {
		walking: {
			right: [rightFrame1wp3, rightFrame2wp3, rightFrame3wp3, rightFrame4wp3],
			left: [leftFrame1wp3, leftFrame2wp3, leftFrame3wp3, leftFrame4wp3],
		},
		falling: {
			right: [fallingRightFrame1wp3, fallingRightFrame2wp3],
			left: [fallingLeftFrame1wp3, fallingLeftFrame2wp3],
		},
	},
};
